module.exports = __webpack_public_path__ + "static/media/6.e7c34759.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/PhuketSkypark/sitePlan/svg/b/6.png
// module id = 968
// module chunks = 0